import LegalPage from '@/components/legal/LegalPage';
import { PASSPORT_TOS_TITLE, PASSPORT_TOS_LAST_UPDATED, PASSPORT_TOS_CONTENT } from '@/legal/tos_passport';

const PassportTerms = () => (
  <LegalPage
    title={PASSPORT_TOS_TITLE}
    lastUpdated={PASSPORT_TOS_LAST_UPDATED}
    content={PASSPORT_TOS_CONTENT}
  />
);

export default PassportTerms;
